import { styled } from "@mui/styles";
import { Tooltip, tooltipClasses, VeBox } from "../../mui";

const BootstrapTooltip = styled(({ className, sx, color, ...props }) => (
  <Tooltip
    {...props}
    sx={{ ...sx }}
    classes={{ popper: className }}
    enterTouchDelay={0}
    leaveTouchDelay={15000}
  />
))(({ theme, color }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: color || "#333333",
    padding: "0px",
    boxShadow: "0px 2px 16px 0px #00000014, 0px 2px 8px -2px #0000001F",
    fontSize: "var(--normal-font-size)",
    maxWidth: "100%",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: color || "#333333",
  },
}));

export function VeTooltip({
  title,
  children,
  width,
  color = "#1D2330",
  placement,
  className,
  sx,
  arrow = false,
}: {
  title: any;
  children: any;
  width?: string;
  color?: string;
  placement: string;
  className?: any;
  sx?: any;
  arrow?: boolean;
}) {
  return (
    <VeBox className={className} sx={{ ...sx }}>
      <BootstrapTooltip
        sx={{ maxWidth: width }}
        color={color}
        title={title}
        arrow={arrow}
        placement={placement}
      >
        {children}
      </BootstrapTooltip>
    </VeBox>
  );
}
